import React, { useState, useEffect, useRef } from "react";
import config from "../../Config";
import axios from "axios";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import FeeSystemMenu from "./FeeSystemMenu";
import { NavLink } from "react-router-dom";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import { scrollToTop } from "../Shared/ScrollOnTop";
import RightsCheck from "../General/RightsCheck";

const MONTH_OPTIONS = [
  { value: 0, label: "All months" },
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

function yearOptions() {
  const y = new Date().getFullYear();
  const opts = [{ value: 0, label: "All years" }];
  for (let i = y - 3; i <= y + 2; i++) {
    opts.push({ value: i, label: String(i) });
  }
  return opts;
}

/** Stable row shape for the grid (PascalCase or camelCase API; shallow copy so UI never mutates shared refs). */
function normalizeChallanListRow(raw) {
  if (!raw || typeof raw !== "object") return null;
  const str = (a, b) => {
    const v = raw[a] ?? raw[b];
    if (v == null || v === "") return null;
    return String(v);
  };
  const num = (a, b, d = 0) => {
    const v = raw[a] ?? raw[b];
    const n = Number(v);
    return Number.isFinite(n) ? n : d;
  };
  return {
    ID: num("ID", "id", 0),
    Challan_No: str("Challan_No", "challan_No"),
    Registration_No: str("Registration_No", "registration_No"),
    Student_ID: num("Student_ID", "student_ID", 0),
    Student_Name: str("Student_Name", "student_Name"),
    Father_Name: str("Father_Name", "father_Name"),
    Wing_Name: str("Wing_Name", "wing_Name"),
    Class_Name: str("Class_Name", "class_Name"),
    Section_Name: str("Section_Name", "section_Name"),
    Month: num("Month", "month", 0),
    Year: num("Year", "year", 0),
    Is_Paid: Boolean(raw.Is_Paid ?? raw.is_Paid),
    ChallanStatus: str("ChallanStatus", "challanStatus"),
    Due_Date_Amount: num("Due_Date_Amount", "due_Date_Amount", 0),
  };
}

function PrintChalanList(props) {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loggedInDisplayName] = useState(
    () =>
      localStorage.getItem("FullName") ||
      localStorage.getItem("UserName") ||
      ""
  );

  const [showFilters, setShowFilters] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [validated, setValidated] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [WingId, setWingId] = useState(0);
  const [SessionId, setSessionId] = useState(
    parseInt(localStorage.getItem("DefaultSession"), 10) || 0
  );
  const [ClassId, setClassId] = useState(0);
  const [SectionID, setSectionID] = useState(0);

  const [Registration_No, setRegistrationNo] = useState("");
  /** Partial match on tblChalanHead.Challan_No (passed to SearchChalanHeads). */
  const [filterChallanNo, setFilterChallanNo] = useState("");
  const [filterStudentId, setFilterStudentId] = useState("");
  const [nameKeywords, setNameKeywords] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(() => new Date().getMonth() + 1);
  const [fYear, setFYear] = useState(() => new Date().getFullYear());
  const [paymentStatus, setPaymentStatus] = useState("");
  const [challanTypeFilter, setChallanTypeFilter] = useState("");
  const [OrderBy, setOrderBy] = useState("Section_Name");

  const [validatedPrint, setvalidatedPrint] = useState(false);
  const [bankExporting, setBankExporting] = useState("");
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  const selectAllCheckboxRef = useRef(null);
  const [refreshTick, setRefreshTick] = useState(0);
  const [deletingId, setDeletingId] = useState(null);

  const allRowsOnPageSelected =
    rows.length > 0 && rows.every((r) => selectedIds.has(Number(r.ID)));
  const someRowsOnPageSelected = rows.some((r) =>
    selectedIds.has(Number(r.ID))
  );

  useEffect(() => {
    document.title = "Print generated challans";
  }, []);

  /** Wing/session drive class list; class drives section list — clear stale ids so API filters stay consistent. */
  useEffect(() => {
    setClassId(0);
    setSectionID(0);
  }, [SessionId, WingId]);

  useEffect(() => {
    setSectionID(0);
  }, [ClassId]);

  useEffect(() => {
    setSelectedIds(new Set());
  }, [
    pageNo,
    pageSize,
    SessionId,
    WingId,
    ClassId,
    SectionID,
    Registration_No,
    filterChallanNo,
    filterStudentId,
    nameKeywords,
    selectedMonth,
    fYear,
    paymentStatus,
    challanTypeFilter,
    OrderBy,
  ]);

  useEffect(() => {
    const el = selectAllCheckboxRef.current;
    if (el) {
      el.indeterminate =
        someRowsOnPageSelected && !allRowsOnPageSelected;
    }
  }, [someRowsOnPageSelected, allRowsOnPageSelected, rows]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: parseInt(UserID, 10) || 0,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      SessionID: SessionId,
      Wing_Id: WingId,
      Class_Id: ClassId,
      Section_Id: SectionID,
      Registration_No: Registration_No,
      Challan_No: filterChallanNo.trim(),
      Student_ID: parseInt(String(filterStudentId).trim(), 10) || 0,
      Keywords: nameKeywords,
      SelectedMonth: selectedMonth,
      FYear: fYear,
      PaymentStatus: paymentStatus,
      ChallanTypeFilter: challanTypeFilter,
      OrderBy: OrderBy,
    };

    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/SearchChalanHeads",
      headers: { "Content-Type": "application/json" },
      data: data,
      timeout: 60000,
    })
      .then(function (response) {
        if (cancelled) return;
        if (response.data.status_code === 1) {
          const list = response.data.ListofRecords || [];
          setRows(
            list
              .map(normalizeChallanListRow)
              .filter(Boolean)
          );
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setRows([]);
          setTotalRecords(0);
        }
      })
      .catch(function () {
        if (!cancelled) {
          setRows([]);
          setTotalRecords(0);
        }
      })
      .finally(function () {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [
    pageNo,
    pageSize,
    SessionId,
    WingId,
    ClassId,
    SectionID,
    Registration_No,
    filterChallanNo,
    filterStudentId,
    nameKeywords,
    selectedMonth,
    fYear,
    paymentStatus,
    challanTypeFilter,
    OrderBy,
    AccessKey,
    UserID,
    MemberType,
    refreshTick,
  ]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setPageNo(1);
    setValidated(true);
  };

  const buildBankExportPayload = (bankExportChallanType) => ({
    AccessKey,
    UserID: parseInt(UserID, 10) || 0,
    MemberType,
    SessionID: SessionId,
    Wing_Id: WingId,
    Class_Id: ClassId,
    Section_Id: SectionID,
    Registration_No: Registration_No,
    Challan_No: filterChallanNo.trim(),
    Student_ID: parseInt(String(filterStudentId).trim(), 10) || 0,
    Keywords: nameKeywords,
    SelectedMonth: selectedMonth,
    FYear: fYear,
    BankExportChallanType: bankExportChallanType,
    BankClientId: "DPSK0925",
    ChalanHeadIds: "",
  });

  const parseFilenameFromDisposition = (header) => {
    if (!header || typeof header !== "string") return null;
    const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
    if (star) return decodeURIComponent(star[1].trim().replace(/^["']|["']$/g, ""));
    const plain = /filename=([^;]+)/i.exec(header);
    if (plain) return plain[1].trim().replace(/^["']|["']$/g, "");
    return null;
  };

  const downloadBankExcel = (challanType) => {
    setBankExporting(challanType);
    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/ExportBankChalanExcel",
      headers: { "Content-Type": "application/json" },
      data: buildBankExportPayload(challanType),
      responseType: "blob",
      timeout: 120000,
    })
      .then((res) => {
        const ct = (res.headers["content-type"] || "").toLowerCase();
        if (ct.includes("application/json")) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const j = JSON.parse(reader.result);
              toast.error(j.status_message || "Export failed.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            } catch {
              toast.error("Export failed.", { position: toast.POSITION.TOP_RIGHT });
            }
          };
          reader.readAsText(res.data);
          return;
        }
        let fname = `DPS_BankChallans_${challanType}_${moment().format(
          "YYYYMMDD_HHmmss"
        )}.xlsx`;
        const fromHdr = parseFilenameFromDisposition(
          res.headers["content-disposition"]
        );
        if (fromHdr) fname = fromHdr;
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        toast.success(`Downloaded ${fname}`, { position: toast.POSITION.TOP_RIGHT });
      })
      .catch(() => {
        toast.error("Network error or timeout during export.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setBankExporting(""));
  };

  const downloadBankExcelSelected = () => {
    const ids = [...selectedIds].map((id) => String(id)).filter(Boolean);
    if (ids.length === 0) {
      toast.error("Select at least one challan.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (ids.length > 15000) {
      toast.error("Too many challans selected (maximum 15,000).", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setBankExporting("Selected");
    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/ExportBankChalanExcel",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType,
        ChalanHeadIds: ids.join(","),
        BankExportChallanType: "Monthly",
        BankClientId: "DPSK0925",
      },
      responseType: "blob",
      timeout: 120000,
    })
      .then((res) => {
        const ct = (res.headers["content-type"] || "").toLowerCase();
        if (ct.includes("application/json")) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const j = JSON.parse(reader.result);
              toast.error(j.status_message || "Export failed.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            } catch {
              toast.error("Export failed.", { position: toast.POSITION.TOP_RIGHT });
            }
          };
          reader.readAsText(res.data);
          return;
        }
        let fname = `DPS_BankChallans_Selected_${moment().format(
          "YYYYMMDD_HHmmss"
        )}.xlsx`;
        const fromHdr = parseFilenameFromDisposition(
          res.headers["content-disposition"]
        );
        if (fromHdr) fname = fromHdr;
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        toast.success(`Downloaded ${fname}`, { position: toast.POSITION.TOP_RIGHT });
      })
      .catch(() => {
        toast.error("Network error or timeout during export.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setBankExporting(""));
  };

  const toggleSelectAllOnPage = () => {
    if (!rows.length) return;
    setSelectedIds((prev) => {
      const allOn = rows.every((r) => prev.has(Number(r.ID)));
      const next = new Set(prev);
      if (allOn) {
        rows.forEach((r) => next.delete(Number(r.ID)));
      } else {
        rows.forEach((r) => next.add(Number(r.ID)));
      }
      return next;
    });
  };

  const toggleRowSelected = (id) => {
    const n = Number(id);
    if (!Number.isFinite(n) || n <= 0) return;
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(n)) next.delete(n);
      else next.add(n);
      return next;
    });
  };

  const handleDeleteChallan = (item) => {
    const hid = Number(item.ID);
    if (!Number.isFinite(hid) || hid <= 0) return;
    if (item.Is_Paid) {
      toast.error("Paid challans cannot be deleted.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    const label = item.Challan_No || String(hid);
    const ok = window.confirm(
      `Delete challan ${label} for ${item.Student_Name || "student"}?\n\n` +
        "This will mark the challan head and all linked tblADLedger fee lines as deleted " +
        "(Is_Deleted) so they no longer appear in normal lists. " +
        "Only unpaid challans can be removed. The server will reject the request if the challan is paid or on a bank scroll."
    );
    if (!ok) return;

    setDeletingId(hid);
    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/DeleteSingleChalanHead",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Admin",
        ChalanHead_Id: hid,
        Name: loggedInDisplayName,
      },
      timeout: 60000,
    })
      .then((res) => {
        if (res.data?.status_code === 1) {
          toast.success(res.data.status_message || "Challan deleted.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setSelectedIds((prev) => {
            const next = new Set(prev);
            next.delete(hid);
            return next;
          });
          setRefreshTick((t) => t + 1);
        } else {
          toast.error(
            res.data?.status_message || res.data?.status_Message || "Delete failed",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.status_message || err.message || "Network error",
          { position: toast.POSITION.TOP_RIGHT }
        );
      })
      .finally(() => setDeletingId(null));
  };

  const buildPrintSearchPayload = () => ({
    AccessKey,
    UserID: parseInt(UserID, 10) || 0,
    MemberType,
    PrintChallanUseSearchPage: true,
    ChalanHeadIds: "",
    SessionID: SessionId,
    Wing_Id: WingId,
    Class_Id: ClassId,
    Section_Id: SectionID,
    Registration_No: Registration_No,
    Challan_No: filterChallanNo.trim(),
    Student_ID: parseInt(String(filterStudentId).trim(), 10) || 0,
    Keywords: nameKeywords,
    SelectedMonth: selectedMonth,
    FYear: fYear,
    PaymentStatus: paymentStatus,
    ChallanTypeFilter: challanTypeFilter,
    OrderBy: OrderBy,
    pageNo,
    pageSize,
  });

  /** One API request = current grid page only (same filters as list). */
  const handlePrintThisPage = () => {
    try {
      sessionStorage.setItem(
        "challanPrintUseSearchPage",
        JSON.stringify(buildPrintSearchPayload())
      );
      window.open("/students/PrintChalanHead/?bySearchPage=1", "_blank");
    } catch {
      /* ignore */
    }
  };

  const handlePrintSelected = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const ids = [...selectedIds].map((id) => String(id)).filter(Boolean);
    setvalidatedPrint(true);
    if (ids.length === 0) return;
    const q = encodeURIComponent(ids.join(","));
    window.open(`/students/PrintChalanHead/?ChalanHeadIds=${q}`, "_blank");
  };

  const renderRows = () => {
    if (!rows.length) {
      return (
        <tr>
          <td colSpan={13}>
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No challans found
            </h4>
          </td>
        </tr>
      );
    }
    return rows.map((item, idx) => {
      const rowId = Number(item.ID);
      const rowKey = `ch-${item.ID}-${item.Month}-${item.Year}-${item.Challan_No || ""}-${idx}`;
      return (
      <tr key={rowKey}>
        <td>
          <div className="form-check">
            <input
              className="form-check-input checkChalanHead"
              type="checkbox"
              checked={selectedIds.has(rowId)}
              onChange={() => toggleRowSelected(rowId)}
              value={String(item.ID)}
              aria-label={`Select challan ${item.Challan_No || item.ID}`}
            />
          </div>
        </td>
        <td>
          <NavLink
            to={`/FeeSystem/ChallanEdit/${item.ID}`}
            title="Edit challan"
            onClick={scrollToTop}
          >
            {item.Challan_No || item.ID}
          </NavLink>
        </td>
        <td>{item.Registration_No}</td>
        <td>{item.Student_Name}</td>
        <td>{item.Father_Name}</td>
        <td>{item.Wing_Name}</td>
        <td>{item.Class_Name}</td>
        <td>{item.Section_Name}</td>
        <td>
          {item.Month}/{item.Year}
        </td>
        <td className="text-end text-nowrap">
          Rs.&nbsp;
          {Number(item.Due_Date_Amount ?? 0).toLocaleString(undefined, {
            maximumFractionDigits: 0,
          })}
        </td>
        <td>
          {item.Is_Paid ? (
            <span className="text-success">Paid</span>
          ) : (
            <span className="text-danger">Unpaid</span>
          )}
        </td>
        <td>{item.ChallanStatus}</td>
        <td>
          <ul className="inline-action">
            <li>
              <NavLink
                to={`/FeeSystem/ChallanEdit/${item.ID}`}
                className="green"
                title="Edit challan"
                onClick={scrollToTop}
              >
                <i className="ri-edit-line"></i>
              </NavLink>
            </li>
            <li>
              <a
                className="blue"
                target="_blank"
                rel="noreferrer"
                title="Print challan"
                href={`/students/PrintChalanHead/?ChalanHeadIds=${encodeURIComponent(
                  String(item.ID)
                )}`}
              >
                <i className="ri-printer-line"></i>
              </a>
            </li>
            <li>
              <button
                type="button"
                className="red print-chalan-delete-btn d-inline-flex align-items-center gap-1"
                style={{ whiteSpace: "nowrap" }}
                title={
                  item.Is_Paid
                    ? "Cannot delete a paid challan"
                    : "Delete challan (unpaid only; not on bank scroll)"
                }
                disabled={
                  loading || deletingId !== null || item.Is_Paid === true
                }
                onClick={() => handleDeleteChallan(item)}
                aria-label={`Delete challan ${item.Challan_No || item.ID}`}
              >
                {deletingId === rowId ? (
                  <Spinner
                    animation="border"
                    role="status"
                    style={{ width: "14px", height: "14px", borderWidth: "2px" }}
                  />
                ) : (
                  <i className="ri-delete-bin-line" aria-hidden="true" />
                )}
                <span>Delete</span>
              </button>
            </li>
          </ul>
        </td>
      </tr>
    );
    });
  };

  return (
    <>
      <FeeSystemMenu />
      <RightsCheck />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Print generated challans
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Print generated challans</div>
                <p className="text-muted small mb-0">
                  Lists challans from tblChalanHead. Filter and print using the
                  same layout as Print Vouchers.
                </p>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <button
                    type="button"
                    onClick={() => setShowFilters((p) => !p)}
                    className="button button-white button-icon"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`collapse ${showFilters ? "show" : ""}`}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="page-content">
              <div className="container">
                <div className="card mb-2">
                  <div className="card-body p-md-4">
                    <div className="row align-items-end gy-3">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Session</label>
                          <select
                            className="form-select"
                            value={SessionId}
                            onChange={(e) =>
                              setSessionId(parseInt(e.target.value, 10) || 0)
                            }
                          >
                            <option value="0">All sessions</option>
                            <SessionsDropDown selectedSession={SessionId} />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Wing</label>
                          <select
                            className="form-select"
                            value={WingId}
                            onChange={(e) =>
                              setWingId(parseInt(e.target.value, 10) || 0)
                            }
                          >
                            <option value="0">All</option>
                            <WingsDropDown selectedWingId={WingId} />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Class</label>
                          <select
                            className="form-select"
                            value={ClassId}
                            onChange={(e) =>
                              setClassId(parseInt(e.target.value, 10) || 0)
                            }
                          >
                            <option value="0">Please select</option>
                            {SessionId !== 0 && WingId !== 0 && (
                              <ClassesDropDown
                                SessionID={SessionId}
                                WingID={WingId}
                                selectedClassId={ClassId}
                              />
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Section</label>
                          <select
                            className="form-select"
                            value={SectionID}
                            onChange={(e) =>
                              setSectionID(parseInt(e.target.value, 10) || 0)
                            }
                          >
                            <option value="0">Please select</option>
                            {ClassId !== 0 && (
                              <SectionDropDown
                                ClassID={ClassId}
                                selectedSectionId={SectionID}
                              />
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Registration no</label>
                          <input
                            type="text"
                            className="form-control"
                            value={Registration_No}
                            onChange={(e) => setRegistrationNo(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Challan no</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Partial match"
                            autoComplete="off"
                            value={filterChallanNo}
                            onChange={(e) => setFilterChallanNo(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Student ID</label>
                          <input
                            type="text"
                            inputMode="numeric"
                            className="form-control"
                            placeholder="Exact match"
                            value={filterStudentId}
                            onChange={(e) => setFilterStudentId(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Keyword search</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Student name, father name, phone / mobile"
                            value={nameKeywords}
                            onChange={(e) => setNameKeywords(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Challan month</label>
                          <select
                            className="form-select"
                            value={selectedMonth}
                            onChange={(e) =>
                              setSelectedMonth(parseInt(e.target.value, 10))
                            }
                          >
                            {MONTH_OPTIONS.map((m) => (
                              <option key={m.value} value={m.value}>
                                {m.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Year</label>
                          <select
                            className="form-select"
                            value={fYear}
                            onChange={(e) =>
                              setFYear(parseInt(e.target.value, 10))
                            }
                          >
                            {yearOptions().map((y) => (
                              <option key={y.value} value={y.value}>
                                {y.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>Payment</label>
                          <select
                            className="form-select"
                            value={paymentStatus}
                            onChange={(e) => setPaymentStatus(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value="Paid">Paid</option>
                            <option value="Unpaid">Unpaid</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Challan kind</label>
                          <select
                            className="form-select"
                            value={challanTypeFilter}
                            onChange={(e) => setChallanTypeFilter(e.target.value)}
                          >
                            <option value="">All kinds</option>
                            <option value="Monthly">Monthly only</option>
                            <option value="Admission">Admission only</option>
                            <option value="Advance">Advance only</option>
                            <option value="Installment">Installment only</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Order by</label>
                          <select
                            className="form-select"
                            value={OrderBy}
                            onChange={(e) => setOrderBy(e.target.value)}
                          >
                            <option value="Section_Name">Section</option>
                            <option value="Student_Name">Student name</option>
                            <option value="Registration_No">
                              Registration no
                            </option>
                            <option value="Student_ID">Student ID (low → high)</option>
                            <option value="Student_ID DESC">
                              Student ID (high → low)
                            </option>
                            <option value="Dated">Date (newest)</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <button
                          type="submit"
                          className="button button-primary mt-4 w-100 d-inline-flex align-items-center justify-content-center gap-2"
                          onClick={() => scrollToTop()}
                        >
                          <i className="ri-search-line" aria-hidden="true" />
                          Apply filters
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <div className="page-content">
          <div className="container">
            <Form
              noValidate
              validated={validatedPrint}
              onSubmit={handlePrintSelected}
            >
              <div className="card mt-2">
                <div className="card-body">
                  <div className="section-title title-sm title-left">
                    Print selected challans
                  </div>
                  <p className="small text-muted">
                    Use the header checkbox to <strong>select all on this page</strong>.
                    Changing page or filters clears the selection.{" "}
                    <strong>Print this page</strong> loads only the current list
                    page (max {pageSize} challans) with your filters.{" "}
                    <strong>Print selected</strong> uses row checkboxes (large
                    selections are fetched in batches of 50). Row <strong>Actions</strong>: edit, print,
                    and <strong>Delete</strong> (unpaid only; removes challan from active use by marking
                    tblChalanHead and tblADLedger rows deleted; blocked if paid or on bank scroll).
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="button button-primary d-inline-flex align-items-center gap-2"
                      onClick={handlePrintThisPage}
                    >
                      <i className="ri-printer-line" aria-hidden="true" />
                      Print this page
                    </button>
                    <button
                      type="submit"
                      className="button button-white d-inline-flex align-items-center gap-2"
                    >
                      <i className="ri-printer-line" aria-hidden="true" />
                      Print selected
                    </button>
                  </div>
                </div>
              </div>
            </Form>

            <div className="card mt-2">
              <div className="card-body">
                <div className="section-title title-sm title-left">
                  Bank upload (Excel)
                </div>
                <p className="small text-muted">
                  Same column layout as the DPS bank sample (<strong>MM/dd/yyyy</strong> text dates,
                  numeric challan no). <strong>Monthly / Admission</strong> downloads use your grid
                  filters, <strong>unpaid only</strong>, up to 15,000 rows.{" "}
                  <strong>Selected rows</strong> exports only checked challans (paid or unpaid), same
                  file layout. <strong>Admission</strong> filter rows include students not yet in{" "}
                  <code>vwStudentDetails</code>; session/wing/class may not apply—use name or
                  registration filters if needed.
                </p>
                <div className="d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="button button-primary d-inline-flex align-items-center gap-2"
                    disabled={!!bankExporting}
                    onClick={() => downloadBankExcel("Monthly")}
                  >
                    <i className="ri-file-excel-2-line" aria-hidden="true" />
                    {bankExporting === "Monthly"
                      ? "Preparing…"
                      : "Download monthly (bank Excel)"}
                  </button>
                  <button
                    type="button"
                    className="button button-white d-inline-flex align-items-center gap-2"
                    disabled={!!bankExporting}
                    onClick={() => downloadBankExcel("Admission")}
                  >
                    <i className="ri-file-excel-2-line" aria-hidden="true" />
                    {bankExporting === "Admission"
                      ? "Preparing…"
                      : "Download admission (bank Excel)"}
                  </button>
                  <button
                    type="button"
                    className="button button-white d-inline-flex align-items-center gap-2"
                    disabled={!!bankExporting}
                    onClick={downloadBankExcelSelected}
                  >
                    <i className="ri-file-excel-2-line" aria-hidden="true" />
                    {bankExporting === "Selected"
                      ? "Preparing…"
                      : "Bank Excel (selected rows only)"}
                  </button>
                </div>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-body">
                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th style={{ width: "44px" }}>
                        <div className="form-check mb-0">
                          <input
                            ref={selectAllCheckboxRef}
                            className="form-check-input"
                            type="checkbox"
                            checked={allRowsOnPageSelected}
                            onChange={toggleSelectAllOnPage}
                            disabled={loading || rows.length === 0}
                            title="Select all challans on this page"
                            aria-label="Select all challans on this page"
                          />
                        </div>
                      </th>
                      <th>Challan no</th>
                      <th>Reg no</th>
                      <th>Name</th>
                      <th>Father</th>
                      <th>Wing</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Period</th>
                      <th className="text-end">Amount (Rs.)</th>
                      <th>Status</th>
                      <th>Challan status</th>
                      <th style={{ minWidth: "150px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan={13}>
                          <Spinner animation="border" role="status" />
                        </td>
                      </tr>
                    ) : (
                      renderRows()
                    )}
                  </tbody>
                </table>
                {totalRecords > pageSize && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page size
                          </label>
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value, 10));
                            }}
                          >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={600}>600</option>
                            <option value={1000}>1000</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrintChalanList;
